import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { Box, Button, IconButton } from '@mui/material';
import React from 'react';
import AdminLayoutView from 'src/Layout/AdminLayout/AdminLayoutView';
import AdminTabs from 'src/Layout/AdminLayout/AdminTabs';
import { AdminTabValue } from 'src/Layout/AdminLayout/AdminTabs/types';
import AdminViewWrapper from 'src/Layout/AdminLayout/AdminViewWrapper';
import useConfirmationDialog from 'src/components/ConfirmationDialog/view';
import GridData from 'src/components/GridData/GridData';
import { TableHeader, TABLE_HEADER_ACTION_SX, TABLE_HEADER_ACTIONS_WRAP_SX } from 'src/components/TableHeader/TableHeader';
import { getDateTimeUSAFormat } from 'src/constants/helpers';
import { useBlocklistViewController } from '../../controllers';
import { BlocklistEntryFormDialog } from '../BlocklistEntryFormDialog';
import { BlocklistValidateDialog } from '../BlocklistValidateDialog';

export const BlocklistView = () => {
  const {
    isPageLoading,
    blocklistFilter,
    blocklistList,
    changeBlocklistSearchFilter,
    changeBlocklistSorting,
    changeBlocklistPagination,
    removeBlocklistItem,
    blocklistEntryFormDialogController,
    openCreateDialogWithSearchValue,
    validateDialogController,
  } = useBlocklistViewController();
  const { openDialog, ConfirmationDialog } = useConfirmationDialog();

  return (
    <>
      <ConfirmationDialog />

      <BlocklistEntryFormDialog {...blocklistEntryFormDialogController} />

      <BlocklistValidateDialog
        isOpen={validateDialogController.isOpen}
        onClose={validateDialogController.close}
      />

      <AdminViewWrapper>
        <AdminLayoutView tabs={<AdminTabs value={AdminTabValue.blocklist} />}>
          <GridData
            header={
              <TableHeader
                searchValue={blocklistFilter.query || ''}
                onSearchChange={changeBlocklistSearchFilter}
                actions={
                  <Box sx={TABLE_HEADER_ACTIONS_WRAP_SX}>
                    <Button
                      onClick={validateDialogController.open}
                      variant="contained"
                      sx={TABLE_HEADER_ACTION_SX}
                    >
                      Text Validation
                    </Button>

                    <Button
                      onClick={openCreateDialogWithSearchValue}
                      variant="contained"
                      sx={TABLE_HEADER_ACTION_SX}
                    >
                      Add to Blocklist
                    </Button>
                  </Box>
                }
              />
            }
            isLoading={isPageLoading}
            rows={blocklistList?.items}
            columns={[
              {
                field: 'word',
                headerName: 'Word/Phrase',
                minWidth: 200,
                editable: false,
                sortable: true,
                flex: 2,
              },
              {
                field: 'dateCreated',
                headerName: 'Created',
                renderCell: r => {
                  return getDateTimeUSAFormat(new Date(r.row.dateCreated));
                },
                minWidth: 150,
                editable: false,
                sortable: true,
                flex: 1,
              },
              {
                field: 'dateUpdated',
                headerName: 'Last Updated',
                renderCell: r => {
                  return getDateTimeUSAFormat(new Date(r.row.dateUpdated));
                },
                minWidth: 150,
                editable: false,
                sortable: true,
                flex: 1,
              },
            ]}
            renderAction={r => {
              return (
                <>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => blocklistEntryFormDialogController.open(r)}
                  >
                    <EditIcon fontSize="inherit" />
                  </IconButton>

                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() =>
                      openDialog({
                        title: `Delete "${r.word}"`,
                        content:
                          'Are you sure you want to remove this word/phrase from the blocklist?',
                        onConfirm: () => removeBlocklistItem(r.id),
                      })
                    }
                  >
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                </>
              );
            }}
            sorting={{
              value: blocklistFilter.sort,
              onChange: changeBlocklistSorting,
            }}
            pagination={{
              page: blocklistFilter.page || 0,
              pageSize: blocklistFilter.limit || 25,
              totalCount: blocklistList?.count,
              onChange: changeBlocklistPagination,
            }}
          />
        </AdminLayoutView>
      </AdminViewWrapper>
    </>
  );
};
